import { useState } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import InboxPersonalCard from './InboxPersonalCard';
import InboxJobDescriptionModal from './InboxJobDescriptionModal';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import { useModalLink } from 'navigation/ModalNavigation';

const Name = styled(Box)`
	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 16px;
`;

function InboxPersonalInformationWithViewer(props: { viewer: graphql.User }) {
	const { localize } = useLocalize();

	const jobPosition = props.viewer.jobPositions[0];
	const jobTitle = localize(jobPosition?.jobTitle.title ?? [])?.text;

	const [modal, setModal] = useState(false);

	const link = useModalLink(`/job-positions/${jobPosition?.id}`);

	return (
		<>
			<PersonAvatar person={props.viewer} size={PersonAvatarSize.MediumLarge} />
			<Name mt={3}>{props.viewer.firstName}</Name>

			{jobTitle && (
				<Box mt={1}>
					<Button
						color="slateBlue"
						link={link}
						title={jobTitle}
						type="plain"
						small
						textAlign="center"
					/>
				</Box>
			)}
			{props.viewer.mission.length > 0 && (
				<Box mt={2}>
					<Paragraph
						color="slateBlue"
						style={{ fontStyle: 'italic', fontSize: 14, textAlign: 'center' }}
					>
						"{props.viewer.mission}"
					</Paragraph>
				</Box>
			)}
			{jobPosition && modal && (
				<InboxJobDescriptionModal jobPosition={jobPosition} onDismiss={() => setModal(false)} />
			)}
		</>
	);
}

export default function InboxPersonalInformation() {
	const query = graphql.useInboxPersonalInformationQuery();

	return (
		<InboxPersonalCard>
			<Flex p={3} alignItems="center" flexDirection="column">
				{query.data ? (
					<InboxPersonalInformationWithViewer viewer={query.data.viewer as graphql.User} />
				) : (
					<Spinner isLoading size="18px" verticalMargin={0} />
				)}
			</Flex>
		</InboxPersonalCard>
	);
}
